import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import customParseFormat from "dayjs/plugin/customParseFormat";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import duration from "dayjs/plugin/duration";
import weekOfYear from "dayjs/plugin/weekOfYear";

// Extend Day.js with all required plugins
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.extend(duration);
dayjs.extend(weekOfYear);

/**
 * Check if a value is a Day.js object
 * @param {unknown} value - The value to check
 * @returns {boolean} - True if value is a Day.js object
 */
export const isDayjs = (value: unknown): boolean => {
  return dayjs.isDayjs(value);
};

export default dayjs;
